module.exports = __webpack_public_path__ + "static/media/user-im2.0c40d125.png";